import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
// import Cookies from 'js-cookie'
import "react-quill/dist/quill.bubble.css";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/App.css";
import "./assets/fonts/fonts.css";
import "react-phone-number-input/style.css";
import { useSelector } from "react-redux";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  Login,
  Register,
  ForgotPassword,
  MyAccount,
  Playground,
  Sports,
  ActiveGames,
  SavedGames,
  SelectPoint,
  FreePoint,
  Payments,
  PaymentsEdit,
  Help,
  Landing,
  PlayReply,
  Play,
  CompletedGames,
  HowToPlay,
} from "./pages";
import ScrollToTop from "./components/ScrollToTop";
import QuarterTest from "./components/Quarter/QuarterTest";

const App = () => {
  const { token, user, isDemo } = useSelector((state) => state.auth);

  useEffect(() => {
    // Reset scroll to top on route change
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route
            path="/landing"
            element={!token ? <Landing /> : <Navigate to="/" />}
          />
          <Route
            path="/login"
            element={!token ? <Login /> : <Navigate to="/" />}
          />
          <Route
            path="/forgotPassword"
            element={!token ? <ForgotPassword /> : <Navigate to="/" />}
          />
          <Route
            path="/register"
            element={!token ? <Help /> : <Navigate to="/" />}
          />

          <Route
            path="/"
            element={token || isDemo ? <Sports /> : <Navigate to="/landing" />}
          />
          <Route
            path="/myaccount"
            element={token ? <MyAccount /> : <Navigate to="/landing" />}
          />
          <Route
            path="/activeGames"
            element={token ? <ActiveGames /> : <Navigate to="/landing" />}
          />
          <Route
            path="/savedGames"
            element={token ? <SavedGames /> : <Navigate to="/landing" />}
          />
          <Route
            path="/howToPlay"
            element={token ? <HowToPlay /> : <Navigate to="/landing" />}
          />
          <Route
            path="/gameHistory"
            element={token ? <CompletedGames /> : <Navigate to="/landing" />}
          />
          <Route
            path="/point/select"
            element={token ? <SelectPoint /> : <Navigate to="/landing" />}
          />
          <Route
            path="/point/free"
            element={
              token || isDemo ? <FreePoint /> : <Navigate to="/landing" />
            }
          />
          <Route
            path="/payments"
            element={token ? <Payments /> : <Navigate to="/landing" />}
          />
          <Route
            path="/paymentsEdit"
            element={token ? <PaymentsEdit /> : <Navigate to="/landing" />}
          />

          <Route
            path="/play"
            element={
              token || isDemo ? <Playground /> : <Navigate to="/landing" />
            }
          />
          <Route path="/playGames" element={<PlayReply />} />

          {/* Test route for Quarter component */}
          <Route path="/quarter-test" element={<QuarterTest />} />

          {/* Catch-all route for undefined routes */}
          <Route
            path="*"
            element={<Navigate to={!token ? "/" : "/landing"} />}
          />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
};

export default App;
